import { useCallback, useContext, useMemo, useState, useEffect } from 'react';
import { API_SERVER_URL } from '../../../../common/utils/utils';
import { UserProfileContext } from '../../../../common/utils/getContext';
import FormComponent from '../../../../widgets/form/FormComponent/FormComponent';
import { getFormStyles, getProfitFilds } from '../../initData';
import { LangContext } from '../../../../common/decorators/Language';
import { t } from '../../../../common/components/T';
import css from './feedback-form.module.scss';

const FeedbackForm = () => {
    const { translation } = useContext(LangContext) || {};
    const { profileData } = useContext(UserProfileContext) || {};
    const formStyle = useMemo(() => getFormStyles(css), [css]);
    const [formDataMain, setFormDataMain] = useState({ contact_type: 'email' });
    const [attempts, setAttempts] = useState(0);
    const setFormData = useCallback((key, value) => {
        setFormDataMain((state) => {
            if (key === 'contact_type' && state?.contact_type !== value) {
                return {
                    ...state,
                    [key]: value,
                    contact: ''
                };
            }
            if (
                key === 'contact' &&
                (state?.contact_type === 'tel' || state?.contact_type === 'viber' || state?.contact_type === 'whatsapp')
            ) {
                return {
                    ...state,
                    [key]: !state[key] || state[key].includes('+') ? value : `+${value}`
                };
            }
            return {
                ...state,
                [key]: value
            };
        });
    }, []);
    const [reload, setReload] = useState(false);

    const afterSenderSuccess = (data, set, setAllowedSend) => {
        setFormDataMain({});
        setAllowedSend(true);
        setReload(!reload);
    };
    const afterSenderError = (data, status, headers, setFieldsErr, setAllowedSend) => {
        setAttempts((prev) => ++prev);
        setAllowedSend(true);
    };

    useEffect(() => {
        if (profileData) {
            const value =
                profileData?.first_name || profileData?.last_name
                    ? [profileData?.first_name, profileData?.last_name]?.filter((e) => e)?.join(' ')
                    : profileData?.username;
            setFormData('guest_name', value);
            setFormData('contact_type', 'email');
        }
    }, [profileData, setFormData, reload]);

    const formFields = useMemo(() => {
        return getProfitFilds(formDataMain, profileData, translation);
    }, [formDataMain, profileData, translation]);

    return (
        <div className={css.blockSendForm}>
            <FormComponent
                data={formFields}
                captcha={{ alias: 'feedback::query_create', attempts }}
                sendData={{
                    url: `${API_SERVER_URL}/api/v1/feedback/queries`,
                    method: 'POST',
                    afterSenderSuccess,
                    afterSenderError
                }}
                funcs={{
                    feedback_query_theme_id: { onChange: (val) => val.value }
                }}
                setFormDataMain={setFormData}
                formDataMain={formDataMain}
                formStyles={formStyle}
                message={{
                    success: t(
                        'success_send_data-1',
                        'Благодарим за Ваше обращание! Мы свяжемся с Вами в ближайшем времени',
                        '/contact',
                        translation
                    ),
                    error: t('error_save_data', 'Ошибка сохранения данных', 'all', translation)
                }}
                buttons={[
                    {
                        type: 'ok',
                        buttonText: t('contactPage-sendmessage-v1', 'Задать вопрос', '/contact', translation)
                    }
                ]}
                customData={{
                    stylesForm: {},
                    customFormButton: {
                        isFullWidth: true
                    }
                }}
            />
        </div>
    );
};
export default FeedbackForm;
